/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from 'three'
import React, {useEffect, useLayoutEffect, useRef} from 'react'
import { useGLTF } from '@react-three/drei'
import { GLTF } from 'three/examples/jsm/loaders/GLTFLoader'
import {IS_MOBILE, ROOT_PATH_PREFIX} from '../../components/common/const'
import {useLoader} from "@react-three/fiber";
import {GLTFLoader} from "three-stdlib";
import {disposeScene} from "../../utils/disposeScene";
import {useKTXLoader} from "../../utils/useKTXLoader";
import useProductStore from "../../stores/productStore";

type GLTFResult = GLTF & {
    nodes: {
        white: THREE.Mesh
        Body: THREE.Mesh
        silver: THREE.Mesh
    }
    materials: {
        white: THREE.MeshStandardMaterial
        silver: THREE.MeshStandardMaterial
    }
}

const GLTF_URL = IS_MOBILE ?
    (ROOT_PATH_PREFIX + '/RP/products/air_care/m/puricare360_air_purifier_pet_ktx2.glb') :
    (ROOT_PATH_PREFIX + '/RP/products/air_care/puricare360_air_purifier_pet_ktx2.glb');
// const GLTF_URL = ROOT_PATH_PREFIX + '/RP/products/air_care/puricare360_air_purifier_pet_ktx2.glb';

export default function Model(props: JSX.IntrinsicElements['group']) {
    const group = useRef<THREE.Group>()
    //@ts-ignore
    const {nodes, materials, scene} = useKTXLoader<GLTFResult>(GLTF_URL);

    const bodyRef = useRef<THREE.Mesh>(null!);
    const selectedColorIndex = useProductStore(state => state.selectedColorIndex);
    const selectedProduct = useProductStore(state => state.selectedProduct);

    //색상 변경 시
    useEffect(() => {
        if (selectedProduct?.modelNo === 'puricare_pet') {
            if (selectedColorIndex === 0) {
                bodyRef.current.material = materials.silver;
            } else if (selectedColorIndex === 1) {
                bodyRef.current.material = materials.white;
            }
            materials.silver.metalness = 0.8;
            materials.silver.envMapIntensity = 3.5;
            materials.white.envMapIntensity = 1;
        }
    }, [selectedProduct, selectedColorIndex]);

    useEffect(() => {
        materials.silver.metalness = 0.8;
        materials.silver.envMapIntensity = 3.5;
        bodyRef.current.material = materials.silver;

        return () => {
            disposeScene(scene);
            useLoader.clear(GLTFLoader, GLTF_URL);
        }
    }, []);

    return (
        <group ref={group} {...props}  dispose={null}>
            <mesh
                geometry={nodes.white.geometry}
                material={materials.white}
                position={[0.3475, 2.456, 0]}
                scale={[0.2241, 0.2241, 0.2241]}
                userData={{ name: 'white' }}
                visible={false}
            />
            <mesh
                geometry={nodes.Body.geometry}
                material={nodes.Body.material}
                position={[0, 0.5439, 0.1963]}
                rotation={[2.7925, 0, -Math.PI]}
                scale={[0.01, 0.01, 0.01]}
                userData={{ name: 'Body' }}
                ref={bodyRef}
            />
            <mesh
                geometry={nodes.silver.geometry}
                material={nodes.silver.material}
                position={[-0.2277, 2.456, 0]}
                scale={[0.2241, 0.2241, 0.2241]}
                userData={{ name: 'silver' }}
                visible={false}
            />
        </group>
    )
}
